import {
  Form,
  Input
} from 'antd'
import React from 'react'

const FormPost = ({
  form,
  handleSearch,
}) => {

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSearch}
        // labelCol={{ span: 8 }}
        labelAlign="right"
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        onValuesChange={(value, allValues) =>
          console.log('vaaaaaa', value, allValues)
        }
      >
          <Form.Item label="" name="id" style={{ display: 'none' }}>
            <Input />
          </Form.Item>
          <Form.Item label="Họ tên" name="name" rules={[{ required: true, message: 'Vui lòng nhập họ tên' }]}>
            <Input placeholder='Nhập họ và tên'/>
          </Form.Item>
          <Form.Item label="Message" name="message" rules={[{ required: true, message: 'Vui lòng nhập nội dung' }]}>
            <Input placeholder='Nhập nội dung'/>
          </Form.Item>
          <Form.Item label="Số điện thoại" name="phone_number">
            <Input placeholder='Nhập số điện thoại'/>
          </Form.Item>
      </Form>
      {/* {mode !== 'ADD' && <Note postId={form.getFieldValue('id')} />} */}
    </>
  )
}

export default FormPost
